import request from "../../../utils/request";

/**
 * 获取当前登录用户菜单树
 * @returns {AxiosPromise}
 */
export function getPositionsTree(params){
    return request({
        url: '/sys/positions/tree',
        method: 'get',
        params
    })
}


/**
 * 编辑菜单
 * @param data
 * @returns {AxiosPromise}
 */
export function editPositions(data){
    return request({
        url: '/sys/positions/edit',
        method: 'post',
        data
    })
}

/**
 * 根据ID删除菜单
 * @param params
 * @returns {AxiosPromise}
 */
export function delPositions(params){
    return request({
        url: '/sys/positions/del',
        method: 'delete',
        params
    })
}

